import intl from 'react-intl-universal';
import { searchSeries } from '@/api/systemSetting';
import { NewGoodType, SelectNewGoodFormType } from '@/type/components';
import { ProForm, ProFormSelect } from '@ant-design/pro-components';
import { message } from 'antd';
import { useState, useEffect } from 'react';
import ProductTableSelect from '../ProductTableSelect';
import { debounce } from 'lodash';
import wtihWatermark from '@/layout/watermark';
import { default as ModalForm } from '@/components/CssModalForm';

type SelectNewProductProps = {
    value?: NewGoodType;
    onValueChange?: (value: NewGoodType) => void;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

const SelectNewProduct: React.FC<SelectNewProductProps> = ({
    value,
    onValueChange,
    open,
    onOpenChange,
}) => {
    // 系列名选项
    const [series, setSeries] = useState<string[]>([]);
    const [currentSeries, setCurrentSeries] = useState<string>();

    // 搜索系列名
    const seriesSearch = debounce((series: string) => {
        if (!series) {
            return;
        }
        searchSeries(series).then((result) => {
            if (result) {
                setSeries(result.map((item) => item.series_name));
            }
        });
    }, 500);

    // 系列名改变
    const seriesChange = (series: string) => {
        setCurrentSeries(series);
    };

    useEffect(() => {
        setCurrentSeries(value?.seriesName);
    }, []);

    // 获取初始值
    const getInitValue = () => {
        if (value) {
            return {
                seriesName: value.seriesName,
                product: {
                    seriesName: value.seriesName,
                    productName: value.productName,
                    productCode: value.productCode,
                    productImage: value.productImage,
                },
            };
        }
        return {};
    };

    const finishAction = (values: SelectNewGoodFormType) => {
        if (!values.product) {
            message.warning(intl.get('请选择商品'));
            return;
        }
        const newGood = {
            seriesName: values.product.seriesName,
            productCode: values.product.productCode,
            productImage: values.product.productImage,
            productName: values.product.productName,
        };

        if (onValueChange) {
            onValueChange(newGood);
        }
    };

    return (
        <ModalForm<SelectNewGoodFormType>
            modalProps={{
                destroyOnClose: true,
                maskClosable: false,
            }}
            layout="horizontal"
            labelWrap={true}
            grid={true}
            title={intl.get('选择新商品')}
            open={open}
            onOpenChange={onOpenChange}
            initialValues={getInitValue()}
            onFinish={finishAction}
        >
            <ProFormSelect
                label={intl.get('系列名称')}
                name="series"
                // colProps={{
                //     span: 20,
                // }}
                fieldProps={{
                    showSearch: true,
                    showArrow: false,
                    filterOption: false,
                    options: series.map((item) => ({
                        value: item,
                        label: item,
                    })),
                    onSearch: seriesSearch,
                    onChange: seriesChange,
                }}
            />

            <ProForm.Item
                name="product"
                style={{ width: '100%' }}
            >
                <ProductTableSelect
                    series={currentSeries || ''}
                    value={value}
                />
            </ProForm.Item>
        </ModalForm>
    );
};

export default wtihWatermark(SelectNewProduct, {
    zIndex: 9999,
    fontColor: '#bbb',
    markStyle: {
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        opacity: 0.3,
    },
});

// export default ;
